import { defineMessages } from 'react-intl';

export default defineMessages({
    serviceRequestNumberMsg: {
        id: 'portal.views.dashboard-table.service-request.ServiceRequestNumber_AX',
        defaultMessage: 'Request Number'
    },
    nextStepColumnMsg: {
        id: 'portal.views.dashboard-table.service-request.NextStepText_AX',
        defaultMessage: 'Next step'
    },
    serviceRequestProgressRequested: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressRequested_AX',
        defaultMessage: 'Requested',
    },
    serviceRequestProgressDeclined: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressDeclined_AX',
        defaultMessage: 'Declined',
    },
    serviceRequestProgressSpecialistWaiting: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressSpecialistWaiting_AX',
        defaultMessage: 'Vendor Waiting',
    },
    serviceRequestProgressInProgress: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressInProgress_AX',
        defaultMessage: 'In Progress',
    },
    serviceRequestProgressWorkComplete: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressWorkComplete_AX',
        defaultMessage: 'Work Complete',
    },
    serviceRequestProgressCanceled: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressCanceled_AX',
        defaultMessage: 'Canceled',
    },
    serviceRequestProgressDraft: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressDraft_AX',
        defaultMessage: 'Pending assignment',
    },
    serviceRequestProgressExpired: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressExpired_AX',
        defaultMessage: 'Expired'
    },
    serviceRequestProgressPendingArrival: {
        id: 'servicerequest.views.service-requests-list.progress.serviceRequestProgressPendingArrival_AX',
        defaultMessage: 'Pending Arrival'
    }
});
